import { RouterProvider } from 'react-router-dom';
import '@locales/i18n';
import '@styles/global.scss';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import { router } from './router';
import { ToastContainer } from 'react-toastify';
import { MantineProvider } from '@mantine/core';
import '@mantine/dates/styles.css';
import ErrorBoundary from '@components/error_boundary';

// Last-resort net: wraps the ENTIRE router, so a render crash in ANY page
// (auth, wallet, or the dev portal) is contained here instead of unmounting
// the whole React tree and blanking the screen. This is deliberately the
// only boundary that can ever be reached with no router context alive
// underneath it, which is why DefaultFallback never depends on
// react-router — see src/UI/layout_providers/developer_provider/index.tsx
// for the dev-portal-specific boundary that catches most real page crashes
// (like 68df4b7a) before they ever reach this one.
const App = () => {
    return (
        <MantineProvider withGlobalClasses>
            <ErrorBoundary>
                <RouterProvider router={router} />
            </ErrorBoundary>
            <ToastContainer autoClose={10000} />
        </MantineProvider>
    );
};

export default App;
